import styled from 'styled-components';

export default styled.div`
  margin-top: 2rem;

  p {
    margin-bottom: 0.5rem;
  }

  p:last-child {
    margin: 0;
  }
`;
